module.exports = __webpack_public_path__ + "static/media/laminar-gri.7eb8293c.svg";